import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '../../lib/utils';
import { Input } from '../../ui/input';

interface ControlledTimePickerProps {
  name: string;
  className?: string;
}

export function ControlledTimePicker({ name, className }: ControlledTimePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Input
          {...field}
          type="time"
          step="1"
          className={cn(
            'appearance-none bg-background [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none',
            className
          )}
        />
      )}
    />
  );
}
